export const enum ApiErrorType {
  MaintenanceMode = 'MaintenanceMode'
}
